var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as EventEmitter from "events";
import * as L from "leaflet";
var mapEAR = /** @class */ (function (_super) {
    __extends(mapEAR, _super);
    function mapEAR() {
        return _super.call(this) || this;
    }
    mapEAR.prototype.init = function () {
        console.log("map init");
        this.mapContainer = document.querySelector("#mapexpe");
        this.geoJSONpath = this.mapContainer.dataset.mapexe;
        this.imgPath = this.mapContainer.dataset.img;
        this.initMap();
    };
    mapEAR.prototype.initMap = function () {
        this.leafletMap = L.map(this.mapContainer, {
            attributionControl: false,
            zoomControl: false,
            boxZoom: false,
            doubleClickZoom: false,
            maxZoom: 19,
            minZoom: 3,
            zoomAnimation: true,
            wheelPxPerZoomLevel: 60,
            zoomDelta: 1,
            zoomSnap: 0,
        });
        var googleSatellite = L.tileLayer("https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", {
            maxZoom: 20,
            subdomains: ["mt0", "mt1", "mt2", "mt3"],
        });
        this.leafletMap.addLayer(googleSatellite);
        this.loadGeoJSON();
    };
    mapEAR.prototype.loadGeoJSON = function () {
        var _this = this;
        var icon = L.icon({
            iconUrl: this.imgPath + "picto_map.png",
            iconSize: [30, 39],
            shadowSize: [30, 39],
            iconAnchor: [15, 39],
            shadowAnchor: [15, 39],
            popupAnchor: [0, -39], // point from which the popup should open relative to the iconAnchor
        });
        var iconParis = L.icon({
            iconUrl: this.imgPath + "picto_paris.png",
            iconSize: [30, 43],
            shadowSize: [30, 43],
            iconAnchor: [15, 43],
            shadowAnchor: [15, 43],
            popupAnchor: [0, -43],
        });
        var iconVarsorvie = L.icon({
            iconUrl: this.imgPath + "picto_varsovie.png",
            iconSize: [30, 43],
            shadowSize: [30, 43],
            iconAnchor: [15, 43],
            shadowAnchor: [15, 43],
            popupAnchor: [0, -43],
        });
        fetch(this.geoJSONpath)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            // console.log(data);
            var i = 0;
            var geo = L.geoJSON(data, {
                pointToLayer: function (feature, latlng) {
                    var currentIcon = icon;
                    if (i == 0) {
                        currentIcon = iconParis;
                    }
                    if (i == 1) {
                        currentIcon = iconVarsorvie;
                    }
                    i++;
                    return L.marker(latlng, { icon: currentIcon });
                },
                // @ts-ignore
                style: function (feature) {
                    return { color: feature.properties.stroke, weight: "3" };
                },
            })
                .bindPopup(function (layer) {
                // @ts-ignore
                return layer.feature.properties.name;
            })
                .addTo(_this.leafletMap);
            //fit map to bounds
            _this.leafletMap.fitBounds(geo.getBounds());
            //Dezoom a bit
            var currentZoom = _this.leafletMap.getZoom();
            _this.leafletMap.setZoom(currentZoom - 0.5);
        });
    };
    return mapEAR;
}(EventEmitter));
export { mapEAR };
